<template>
  <div
    class="dui-tab"
    :class="{
      active: isActive
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.dui-tab {
  display: none;

  &.active {
    display: block;
  }
}
</style>
